import { useState, useCallback, useEffect } from "react";
import { Employee } from "../types";
import { useGetLocationEmployeesQuery } from "../services/managersApi";

export const useEmployeeSelection = (locationId?: number) => {
  const [selectedEmployee, setSelectedEmployee] = useState<Employee | null>(
    null,
  );
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const {
    data: employeesData,
    error: employeesError,
    isFetching: isLoadingEmployees,
  } = useGetLocationEmployeesQuery(locationId ?? 0, {
    skip: !locationId,
  });

  const selectEmployee = useCallback((employee: Employee) => {
    setSelectedEmployee(employee);
    setDropdownOpen(false);
  }, []);

  const toggleDropdown = useCallback(
    () => setDropdownOpen(!dropdownOpen),
    [dropdownOpen],
  );
  const closeDropdown = useCallback(() => setDropdownOpen(false), []);

  useEffect(() => {
    if (employeesData?.employees?.length === 1 && !selectedEmployee) {
      setSelectedEmployee(employeesData.employees[0]);
    }
  }, [employeesData]);

  return {
    employees: employeesData?.employees || [],
    selectedEmployee,
    dropdownOpen,
    isLoadingEmployees,
    employeesError,
    selectEmployee,
    toggleDropdown,
    closeDropdown,
  };
};
